import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home } from 'lucide-react';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-500 to-primary-700 px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          {/* 404 Icon */}
          <div className="mx-auto h-24 w-24 bg-red-100 rounded-full flex items-center justify-center mb-6">
            <span className="text-4xl font-bold text-red-600">404</span>
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Page Not Found</h1>
          <p className="text-gray-600 mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>

          {/* Home Button */}
          <button
            onClick={() => navigate('/calendar')}
            className="w-full flex items-center justify-center px-6 py-4 border border-transparent rounded-xl shadow-lg text-white bg-accent-500 hover:bg-accent-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent-500 transition font-semibold text-lg"
          >
            <Home className="h-5 w-5 mr-2" />
            Start Page
          </button>
        </div>

        {/* Footer */}
        <p className="mt-6 text-center text-sm text-white opacity-90">
          © 2025 SharedEasy. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default NotFoundPage;

